import {useSearchParams} from "react-router-dom";
import { QUERY_PARAM_LIMIT } from "../../config/utils";
import {getStateValues, isTokenExpired, navigateToLogin, setStateValues, State} from "../../services/auth";

export const useTestParams = () => {
  const [searchParams] = useSearchParams();
  const {fn, kfn }: State = {fn: [], kfn: [] };
  Array.from(searchParams.entries()).forEach(([key, value]) => {
    if (value !== 'null') {
      switch (key) {
        case "kfn":{
          if (kfn.length < QUERY_PARAM_LIMIT && !kfn.includes(value)) {
            kfn.push(value);
          }
          break;
        }
        case "fn":{
          if (fn.length < QUERY_PARAM_LIMIT && !fn.includes(value)) {
            fn.push(value);
          }
          break;
        }
      }
    }
  });

  const state = (fn.length === 0 && kfn.length === 0) ? getStateValues() : { kfn, fn, };
  setStateValues(state);
  const token = localStorage.getItem("idToken");
  try {
    if (!token) {
      navigateToLogin();
      return state;
    }
    if (isTokenExpired()) {
      navigateToLogin();
      return state;
    }
  } catch (error) {
    navigateToLogin();
    return state;
  }
  return state;
}